import { render, staticRenderFns } from "./EmployeeabsencePage.vue?vue&type=template&id=7a904bba"
import script from "./EmployeeabsencePage.vue?vue&type=script&lang=js"
export * from "./EmployeeabsencePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports